'use client';

import { useState, useEffect } from 'react';
import './BackToTopButton.scss';
import { Button } from '@petsmart-ui/sparky';
import { dataLayerPush } from '@libs/analytics';

export default function BackToTopButton() {
    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const { scrollY } = window;
            const viewportHeight = window.innerHeight;

            setShowButton(scrollY > viewportHeight);
        };
        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
        dataLayerPush({
            event: 'nav_click',
            nav_section: 'back to top',
            selection: 'top',
        });
    };

    if (!showButton) {
        return null;
    }

    return (
        <Button
            data-testid="back-to-top-button-test"
            className="back-to-top-button"
            text="Back to top button"
            iconName="chevron-up"
            hideText
            iconSize="lg"
            onClick={scrollToTop}
            variant="primary"
        />
    );
}
